import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=87e698aa&scoped=true"
import script from "./AiChatWidget.vue?vue&type=script&lang=js"
export * from "./AiChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AiChatWidget.vue?vue&type=style&index=0&id=87e698aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e698aa",
  null
  
)

export default component.exports